var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.648 2.352a3 3 0 0 1 4.52.322l1.82 2.424a3 3 0 0 1-.28 3.921l-1.34 1.341c.13.338.558 1.08 1.86 2.383 1.302 1.302 2.044 1.73 2.383 1.86l1.34-1.34a3 3 0 0 1 3.921-.28l2.425 1.819a3 3 0 0 1 .321 4.521l-1.191 1.191c-.714.714-2.23 1.381-3.764 1.448-2.401.104-5.663-.962-9.678-4.977-4.014-4.014-5.08-7.276-4.976-9.677.058-1.336.483-2.803 1.453-3.759.695-.706.785-.796 1.186-1.197Zm-.641 5.042c-.073 1.665.629 4.414 4.393 8.177 3.763 3.764 6.512 4.465 8.176 4.393 1.554-.068 2.388-.819 2.437-.864l1.19-1.191a1 1 0 0 0-.106-1.507l-2.425-1.819a1 1 0 0 0-1.307.093c-.53.53-.892.898-1.6 1.603-1.472 1.467-3.99-1.162-4.951-2.122-.883-.883-3.573-3.482-2.124-4.947l1.604-1.605a1 1 0 0 0 .093-1.307L7.57 3.874a1 1 0 0 0-1.507-.107c-.396.396-.844.844-1.19 1.192-.711.716-.827 1.56-.865 2.435Z",
    fill: "#777E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLine;